import { Box } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import styles from "./styles";

const useStyles = makeStyles(styles);
export interface IPictureCell {
  link?: string;
  onClick?: () => void;
  width?: string | number;
  height?: string | number;
}

const PictureCell = ({ link, onClick, width, height }: IPictureCell) => {
  const classes = useStyles();
  if (!link) {
    return null;
  }
  return (
    <Box
      className={classes.CellImageContainer}
      onClick={onClick}
      style={{
        ...(width !== undefined && { width }),
        ...(height !== undefined && { height }),
      }}
    >
      <img
        className={classes.CellImage}
        src={link}
        loading="lazy"
        style={{
          ...(width !== undefined && { minWidth: width, width }),
          ...(height !== undefined && { minHeight: height, height }),
          ...((width !== undefined || height !== undefined) && {
            objectFit: "contain",
          }),
        }}
      />
      {/* Replace img tag with placeholder below if performance becomes an issue */}
      {/* <span className="material-icons" style={{ color: lightgray }}>
        image
      </span> */}
    </Box>
  );
};

export default PictureCell;
